import { CACHE_WORKER_VERSION } from './config';

export default function registerServiceWorker() {
    if ('serviceWorker' in navigator) {
        window.addEventListener('load', async () => {
            let isRegistered = false;
            await navigator.serviceWorker.getRegistrations().then((registrations) => {
                for (const registration of registrations) {
                    if (registration.active?.scriptURL.includes('cache-worker-v')) {
                        if (
                            !registration.active.scriptURL.includes(
                                `cache-worker-${CACHE_WORKER_VERSION}`
                            )
                        ) {
                            registration.unregister();
                        } else {
                            isRegistered = true;
                        }
                    }
                }
            });
            if (isRegistered) {
                return;
            }
            navigator.serviceWorker
                .register(`/cache-worker-${CACHE_WORKER_VERSION}.js`)
                .then((registration) => {
                    console.log('Service Worker зарегистрирован:', registration);
                })
                .catch((error) => {
                    console.error('Ошибка регистрации Service Worker:', error);
                });
        });
    }
}
